import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TournamentsResponse } from '../../../all-tournaments/models/api/responses/tournaments.response';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import { HomeService } from '../../services/home.service';
import { HomeActions } from '../actions/actions-type.action';

@Injectable()
export class HomeEffect {
    private actions$ = inject(Actions);
    private homeService = inject(HomeService);

    fetchHomeTournaments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(HomeActions.fetchHomeTournaments),
            mergeMap((action) =>
                this.homeService.fetchHomeTournaments(action.payload).pipe(
                    map((response: TournamentsResponse) =>
                        HomeActions.fetchHomeTournamentsSuccess({
                            payload: {
                                type: action.payload.type,
                                response,
                                patchExistingValue:
                                    !!action.payload.patchExistingValue,
                            },
                        })
                    ),
                    catchError((response: BadResponseWithError) =>
                        of(
                            HomeActions.fetchHomeTournamentsFailure({
                                payload: response,
                            })
                        )
                    )
                )
            )
        )
    );
}
